import { InputFieldProps } from "./types";

export const NumberInput: React.FC<InputFieldProps> = ({ inputValue, onUpdate }) => (
	<div>
		<input
			onChange={(e) => onUpdate?.(Number.isNaN(e.target.valueAsNumber) ? undefined : e.target.valueAsNumber)}
			type="number"
			value={inputValue ?? ""}
			className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
		/>
	</div>
);
